import React from 'react';

const Footer = () => (
	<div className="footer">
		&copy; Copyright 2019{' '}
		<a href="https://rodrigodlpontes.github.io/website/">Rodrigo Pontes</a>, under the direction
		of Mary Hudachek-Buswell, &copy; Copyright 2011&nbsp;
		<a href="http://www.cs.usfca.edu/galles">David Galles</a>
	</div>
);

export default Footer;
